
/* eslint-disable import/prefer-default-export */
export const INIT_RULE = {
  EI: {
    field: 'OBJECT_NAME',
    op: 'eq',
    value: '',
    key: '',
    display: '',
  },
  AI: {
    field: 'OBJECT_NAME',
    op: 'eq',
    value: '',
    key: '',
    display: '',
  },
  APP: {
    field: 'platform',
    op: 'eq',
    value: '',
    key: '',
    display: '',
  },
};

export const INIT_FILTER = {
  EI: {
    rule: [[{ ...INIT_RULE.EI }]],
    name: '',
    category: 'CONTENT',
    subcategory: 'Asset',
    fid: 0,
    saving: false,
    isContent: false,
  },
  AI: {
    rule: [[{ ...INIT_RULE.AI }]],
    name: '',
    category: 'CONTENT',
    subcategory: 'Asset',
    fid: 0,
    saving: false,
    isContent: false,
  },
  APP: {
    rule: [[{ ...INIT_RULE.APP }]],
    name: '',
    category: 'Content',
    subcategory: 'Application',
    fid: 0,
    saving: false,
    isContent: false,
  },
};
